<template>
    <div class="compare">
        <div class="content">
            <div v-if="getCompareList && getCompareList[getType()]" class="table-responsive">
                <table style="display:inline-block" class="table attribs" data-sort="table">
                    <thead >
                        <tr>
                            <td v-if="getType() == 'cpu' || getType() == 'gpu' || getType() == 'graphics'" style="padding-top: 12px; padding-bottom: 13px;  align-items:center; height: 87px;">
                              Performance
                            </td>
                            <td v-if="getType() == 'cpu' || getType() == 'gpu' || getType() == 'graphics'"  style="padding-top: 12px; padding-bottom: 13px; ">Model</td>
                            <td v-else style="padding-top: 12px; padding-bottom: 13px; ">Model</td>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(item, index) in getComparisonFields(getCompareList[getType()][0].specs)" :key="index"  >
                            <td class="attrib">{{item}}</td>
                        </tr>
                    </tbody>
                </table>
                <table style="display:inline-block" v-for="(item, index) in getCompareList[getType()]" :key="index"  class="table" data-sort="table">
                    <thead >
                        <tr>
                            <div style="text-align: center;">
                                <vue-speedometer v-if="getType() == 'cpu' || getType() == 'gpu' || getType() == 'graphics'"   class="speedometer"
                                    :height="79"
                                    :width="140"
                                    :needleHeightRatio="0.6"
                                    valueTextFontSize="14px"
                                    :value="perf[item.id]"
                                    :maxValue="50"
                                    :segments="3"
                                    currentValueText=""
                                    :segmentColors='["#c7254e", "#e1d420", "#18b37e" ]'
                                    :ringWidth="4"
                                    :needleTransitionDuration="1000"
                                    needleTransition="easeQuadInOut"
                                    needleColor="#cfd2da"
                                    textColor="#1997c6"
                                    :fontWeight="'200'"
                                    :ref="'speedometer'"
                                    :forceRender='true'
                                    :customSegmentLabels='[
                                        {
                                            text: "Slow",
                                            position: "OUTSIDE",
                                            color: "#9198aa",
                                        },
                                        {
                                            text: " ",
                                            position: "OUTSIDE",
                                            color: "#9198aa",
                                        },
                                        {
                                            text: "Fast",
                                            position: "OUTSIDE",
                                            color: "#9198aa",
                                        },
                                    ]'
                                />
                            </div>
                            <td class="model">
                                <div  @click="setLayout('advanced')" >
                                    <router-link :to="'/builder/'+getType()+'?view=slider&id='+item.id + '&redir=true'">{{item.model}} </router-link>
                                </div>
                                <button class="btn-reset" @click="removeFromCompare(item)"><span style="color: #434857"  class="icon icon-circle-with-cross"></span></button>
                            </td>

                        </tr>
                    </thead>
                    <tbody >
                        <tr class="" v-for="(spec,index) in Object.keys(item.specs)" :key="index">
                            <td v-if=" Object.keys(welcomedList).includes(Object.keys(item.specs)[index])" class="spec">{{item.specs[spec]}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-bottom: 25px; margin-left: 15px;" v-if="!getCompareList[getType()]">
                <h6 class="empty">Comparison table is empty</h6>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions }   from 'vuex'
import VueSpeedometer               from "vue-speedometer"
export default {
    name: "Compare",
    components: {
        VueSpeedometer,
    },
    watch: {
        getCompareList(n) {
            if(n){
                this.countPerf(n)
            }
        }
    },
    data () {
        return { 
            perf: {},
            welcomedList: {
                // CPU
                'Core_Frequency':       'Core Frequency',
                'Turbo_Frequency':      'Turbo Frequency',
                'Number_of_Cores':      'Number of Cores',
                'Number_of_Threads':    'Number of Threads',
                'Generation':           'Generation',
                'Cache_Memory':         'Cache Memory',
                'Hyper_Threading':      'Hyper Threading',
                'Turbo_Boost':          'Turbo Boost',
                // GPU
                'graphics_processor':   'Graphics Processor',
                'GPU_clock_speed':      'GPU Clock Speed',
                'memory_clock_speed':   'Memory Clock Speed',
                'graphics_ram_type':    'Memory Type',
                'graphics_ram_capacity':'Memory Capacity',
                'memory_transfer_speed':'Memory Transfer Speed',
                'graphics_interface':   "Interface",
                'tdp':                  'Power Consumption',
                'VR':                   'VR Ready',
                // PSU
                'wattage':              'Output Watts',
                'modular':              'Modular',
                'eco_mode':             'Eco Mode',
                'energy_rating':        'Energy Rating',
                // Case
                'form_factor':          'Form_Factor',
                'tempered_glass':       'Tempered Glass',
                'dimentions':           'Dimentions',
                'weight':               'Weight',
                'color':                'Color',
                // RAM
                'RAM_Type':             'RAM Type',
                'Capacity':             'Capacity',
                'RAM_Speed':            'RAM Speed',
                'Number_of_Sticks':     'Number of Sticks',
                'Pins':                 'Pins',
                'ECC':                  'ECC',
                'TDP':                  'Power Consumption',
                // MB
                'Socket':               'Socket',
                'WiFi':                 'Integrated Wifi',
                'Integrated_Graphics':  'Integrated Graphics',
                'Compatible_Memory':    'Compatible Memory',
                'Bus_Speed':            'Bus Speed',
                'USB':                  'Supported USB',
                'Max_Memory_Size':      'Maximum RAM Amount',
                'ECC_Support':          'ECC Support',
            },
        }
    },
    methods: {
        ...mapActions([
            'removeFromCompare',
            'setLayout'
        ]),
        countPerf(compareList){
            console.log(this.$refs.speedometer)
            var items = compareList[this.getType()]
            if(items && items.length > 0){
                items.map((item) => {
                    if(!this.perf[item.id]){
                        this.perf[item.id] = {}
                    }
                    this.perf[item.id] = parseInt(item.performance)
                })
            }
        },
        getComparisonFields(specs){
            var welcomed = Object.keys(this.welcomedList)
            var specifications = Object.keys(specs)
            var result = []
            specifications.map((item) => {
                if(welcomed.includes(item)){
                    result.push(this.welcomedList[item])
                }
            })
            return result
        },
        getType(){
            this.type = this.$route.path.replace(/\\|\/builder\//g,'') 
            return this.type
        },
    },
    computed: {
        ...mapGetters([
            'getCompareList',
            'lastRoute'
        ]),
    },
    created(){
        this.countPerf(this.getCompareList)
    }
}
</script>

<style scoped>

thead {
    color: #1997c6;
}
.empty {
    margin-top: 20px;
    color: #434857 !important;
}
td {
    height: 46px;
    display: flex !important;
}
td a {
    color:#1997c6 !important;
}
.compare {
    height: 100%;
    overflow: auto;
    margin-left: -5px;
    margin-top: 4px;
}
.btn-reset {
    background: transparent;
    border: none;
    margin-right: 0px;
    margin-left: -3px;
    font-weight: unset;
    font-size: 10pt;
    padding-top: 2px;
    color: #E6474B !important;
    overflow: hidden;
    outline: none;
}
.btn-reset:hover {
    cursor: pointer;
    transform: scale(1.1) !important;
}
.speedometer{
    border-top: 1px solid #434857;
}
.attrib {
    padding-right: 40px;
    color: #9198aa;
}
.spec {
    border-left: 1px solid #434857;
    width: 100% !important;
    color: #cfd2da;
    text-align: center;
}
.table {
    width: unset;
    vertical-align: top;
}
.table-responsive {
    max-height: 595px;
}
</style>
